// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2KEs-","header":"MergedInvoice_header__2FSwn"};